var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component, createRef, Children } from "react";
import SliderFullscreenThumbnails from "./SliderFullscreenThumbnails";
import { Container, Content, Slider, MobileSlider, MobileSlide } from "./styled/slider-fullscreen";

var SliderFullscreen =
/** @class */
function (_super) {
  __extends(SliderFullscreen, _super);

  function SliderFullscreen() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ref = createRef();
    _this.state = {
      currentSlideIndex: _this.props.initialIndex || 0,
      isSliding: false
    };

    _this.handleOnPrev = function (_a) {
      var nextSlideIndex = _a.nextSlideIndex,
          isSliding = _a.isSliding;

      _this.setState({
        currentSlideIndex: nextSlideIndex,
        isSliding: isSliding
      });
    };

    _this.handleOnNext = function (_a) {
      var nextSlideIndex = _a.nextSlideIndex,
          isSliding = _a.isSliding;

      _this.setState({
        currentSlideIndex: nextSlideIndex,
        isSliding: isSliding
      });
    };

    _this.handleOnNav = function (_a) {
      var nextSlideIndex = _a.nextSlideIndex,
          isSliding = _a.isSliding;

      _this.setState({
        currentSlideIndex: nextSlideIndex,
        isSliding: isSliding
      });
    };

    _this.handleOnSlide = function (_a) {
      var isSliding = _a.isSliding;

      _this.setState({
        isSliding: isSliding
      });
    };

    _this.handleOnThumbnailClick = function (index) {
      if (index === _this.state.currentSlideIndex) return;

      _this.setState({
        currentSlideIndex: index,
        isSliding: true
      });
    };

    return _this;
  }

  SliderFullscreen.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children;
    var _b = this.state,
        currentSlideIndex = _b.currentSlideIndex,
        isSliding = _b.isSliding;
    return React.createElement(Container, {
      ref: this.ref,
      className: className
    }, React.createElement(Content, null, React.createElement(Slider, {
      autoFocus: true,
      currentSlideIndex: currentSlideIndex,
      showDots: false,
      loadAllImages: true,
      onPrev: this.handleOnPrev,
      onNext: this.handleOnNext,
      onNav: this.handleOnNav,
      onSlide: this.handleOnSlide
    }, children), React.createElement(MobileSlider, null, Children.map(children, function (child, index) {
      return React.createElement(MobileSlide, {
        key: index
      }, child);
    }))), React.createElement(SliderFullscreenThumbnails, {
      parentRef: this.ref,
      currentSlideIndex: currentSlideIndex,
      isSliding: isSliding,
      onClick: this.handleOnThumbnailClick
    }, children));
  };

  return SliderFullscreen;
}(Component);

export default SliderFullscreen;